import React from "react";
import AuthPageV2 from "./auth/AuthPageV2";

const OTPLoginPage: React.FC = () => <AuthPageV2 mode="login" />;

export default OTPLoginPage;
